<template>
  <div class="mt-4">
    <div v-if="currentCategory" class="mt-2 px-4 flex items-center gap-3">
      <p class="text-sm text-secondary font-bold">Category:</p>
      <Chip closable @close="emit('close-category')">
        {{ currentCategory.name }}
      </Chip>
    </div>

    <div v-if="currentSubcategory" class="mt-2 px-4 flex items-center gap-3">
      <p class="text-sm text-secondary font-bold">Subcategory:</p>
      <Chip closable @close="emit('close-subcategory')">
        {{ currentSubcategory.name }}
      </Chip>
    </div>

    <div
      v-if="filters.type.length > 0"
      class="mt-2 px-4 flex items-center flex-wrap gap-3"
    >
      <p class="text-sm text-secondary font-bold">Type:</p>
      <Chip
        v-for="(selectedType, index) in selectedTypes"
        :key="`selected-type-${index}`"
        closable
        @close="emit('close-type', selectedType.key)"
      >
        {{ selectedType.label }}
      </Chip>
    </div>

    <div
      v-if="filters.tagIds.length > 0"
      class="mt-2 px-4 flex items-center flex-wrap gap-3"
    >
      <p class="text-sm text-secondary font-bold">Tags:</p>
      <Chip
        v-for="(selectedTag, index) in selectedTags"
        :key="`selected-tag-${index}`"
        closable
        @close="emit('close-tag', selectedTag.id)"
      >
        {{ selectedTag.name }}
      </Chip>
    </div>

    <div
      v-if="filters.status.length > 0"
      class="mt-2 px-4 flex items-center flex-wrap gap-3"
    >
      <p class="text-sm text-secondary font-bold">Status:</p>
      <Chip
        v-for="(selectedStatus, index) in selectedStatuses"
        :key="`selected-status-${index}`"
        closable
        @close="emit('close-status', selectedStatus.key)"
      >
        {{ selectedStatus.label }}
      </Chip>
    </div>
  </div>
</template>
<script setup lang="ts">
import { Chip } from '~/components/chip';
import { computed } from '#imports';
import { Nullable } from '~/types/common';
import { HubCategoryDto, HubSubcategoryDto, HubTagDto } from '~/api/hubs';
import { HubMobileFilters } from '~/pages/_components/hub-details/_components/filters-modal/_components/mobile-filters/mobile-filters.vue';
import { USE_LUNCH_METRICS_OPTIONS } from '~/pages/_components/hub-details/_components/filters-modal/_constants';

type Props = {
  filters: HubMobileFilters;
  currentCategory: Nullable<HubCategoryDto>;
  currentSubcategory: Nullable<HubSubcategoryDto>;
  typeOptions: { key: string; label: string }[];
  tags: HubTagDto[];
};

const props = defineProps<Props>();

const emit = defineEmits<{
  'close-category': [];
  'close-subcategory': [];
  'close-type': [value: string];
  'close-tag': [value: number];
  'close-status': [value: string];
}>();

const selectedTypes = computed<{ key: string; label: string }[]>(() => {
  return props.typeOptions.filter((type) =>
    props.filters.type.includes(type.key),
  );
});

const selectedTags = computed<HubTagDto[]>(() => {
  return props.tags.filter((tag) => props.filters.tagIds.includes(tag.id));
});
const LUNCH_METRICS_OPTIONS = USE_LUNCH_METRICS_OPTIONS();
const selectedStatuses = computed(() => {
  return LUNCH_METRICS_OPTIONS.value.filter((metric) =>
    props.filters.status.includes(metric.key),
  );
});
</script>
